export default "__VITE_ASSET__NtFS$cNl__"